import React, { useContext } from "react";
import classNames from "classnames";

import Overlay from "../overlay/OverlayController.jsx";
import Logo from "../logo/Logo.jsx";
import Icon from "../icon/Icon.jsx";
import Payment from "../payment/PaymentController.jsx";
import Profile from "../profile/ProfileController.jsx";
import { Tabs, Tab, TabButtons, TabButton } from "../tabs/Tabs.jsx";
import { GlobalContext } from "../../globals/globalContext";
import { Context as LoginContext } from "../login/LoginController.jsx";
import { FormattedMessage } from "react-intl";

export default function Register(props) {
  const {
    className,
    gmbhName,
    colorPrimary,
    logoSmallUrl,
    conditionsPage,
    address,
    post_city,
    is_shipping,
    isDeliveryAddress,
    addInvoicePaymentMethod,
    addSepaPaymentMethod,
    paymentProvider,
    timeframe,
    activeTab,
    onProfileSuccess,
    onPaymentSuccess,
    onCloseDialogClick,
    setShowRegistrationForm,
    active,
  } = props;

  const { subscription, delivery_address } = useContext(GlobalContext);
  const { setIsAuthenticated } = useContext(LoginContext);
  const handleClose = () => {
    onCloseDialogClick && onCloseDialogClick();
    setShowRegistrationForm && setShowRegistrationForm();
  };

  return (
    <Overlay
      className={classNames("register", className)}
      active={active}
      isRegistration={true}
    >
      <div className="register__close">
        <TabButton id="close" className="register__close">
          <div onClick={handleClose}>×</div>
        </TabButton>
      </div>
      <div className="register__header">
        <Logo className="register__logo" logoSmallUrl={logoSmallUrl} />
        <div className="register__title">
          <FormattedMessage id="register" />
        </div>
        <TabButtons className="register__tabs__buttons" active={activeTab}>
          <TabButton id="profile" className="register__tabs__button">
            <Icon name="user" />
          </TabButton>
          <TabButton id="payment" className="register__tabs__button">
            <Icon name="card" />
          </TabButton>
        </TabButtons>
      </div>
      <Tabs
        className="register__tabs"
        active={activeTab}
        colorprimary={colorPrimary}
      >
        <Tab id="profile" className="register__tab">
          <Profile
            isDeliveryAddress={isDeliveryAddress}
            post_city={post_city}
            is_shipping={is_shipping}
            address={address}
            timeframe={timeframe}
            customer={subscription.customer}
            delivery_address={delivery_address}
            onSuccess={onProfileSuccess}
            gmbhName={gmbhName}
            conditionsPage={conditionsPage}
            isRegistration={true}
            setIsAuthenticated={setIsAuthenticated}
          />
        </Tab>
        <Tab id="payment" className="register__tab">
          <Payment
            onSuccess={onPaymentSuccess}
            addInvoicePaymentMethod={addInvoicePaymentMethod}
            addSepaPaymentMethod={addSepaPaymentMethod}
            paymentProvider={paymentProvider}
            isFromRegistrationForm={true}
            gmbhName={gmbhName}
          />
        </Tab>
      </Tabs>
    </Overlay>
  );
}
